import { render, staticRenderFns } from "./BonusPrice.vue?vue&type=template&id=5d25ff07&"
import script from "./BonusPrice.vue?vue&type=script&lang=ts&"
export * from "./BonusPrice.vue?vue&type=script&lang=ts&"
import style0 from "./BonusPrice.vue?vue&type=style&index=0&id=5d25ff07&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports